<a
  class="navigation-header-notifications__link"
  [href]="notificationsUrl"
  [attr.target]="externalHrefTarget"
  [attr.aria-label]="ariaLabel"
  [ngfBadge]="displayCount"
  [ngfBadgeHidden]="!hasUnread"
  (click)="clearUnread()">
  <img src="assets/images/icons/bell-01.svg" alt="" aria-hidden="true" width="24" height="24" />
</a>
